import "../features/product/hydration/ProductsContainerHydration";
import "../features/product/hydration/SingleProductContainerHydration";

// Define types for our component mappings
interface ComponentMapping {
  id: string;
  hydrateFn: string;
}

// Define global hydration functions that will be attached to window
declare global {
  interface Window {
    hydrateProductsContainer?: (id: string) => void;
    hydrateSingleProductContainer?: (id: string) => void;
    [key: string]: any; // Allow dynamic access to other potential hydration functions
  }
}

/**
 * Initialize all component hydration functions
 */
const initHydration = (): void => {
  console.log("Hydration system initialized");

  // Automatically detect and hydrate components
  const componentMappings: ComponentMapping[] = [
    { id: "products-archive-root", hydrateFn: "hydrateProductsContainer" },
    { id: "single-product-root", hydrateFn: "hydrateSingleProductContainer" },
  ];

  componentMappings.forEach(({ id, hydrateFn }) => {
    const rootElement = document.getElementById(id);
    if (rootElement && typeof window[hydrateFn] === "function") {
      if (rootElement.dataset.reactInitialized !== "true") {
        window[hydrateFn](id);
      } else {
        console.log(
          `Skipping hydration for already initialized container: ${id}`
        );
      }
    } else if (rootElement && typeof window[hydrateFn] !== "function") {
      console.warn(
        `Hydration function ${hydrateFn} not found for element ${id}`
      );
    }
  });
};

// If we're in a browser environment, initialize hydration on DOMContentLoaded
if (typeof window !== "undefined") {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHydration);
  } else {
    initHydration();
  }
}

export default initHydration;
